import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesCustomFieldsConfigRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-custom-fields-config',
	path: '/secure/admin/ConfigureCustomField!default.jspa',
};
